module.exports = __webpack_public_path__ + "static/background-574a071beb3b593312e3f4f45321d62b.png";